import { currentCollection } from "@/composables/use-polly";

const CONTACTCENTER_STEP = "contactCenterStep";

export const saveStepToLocalStorage = (): void =>
	localStorage.setItem(CONTACTCENTER_STEP, currentCollection.value ? currentCollection.value?.id : "");
export const getStepLocalStorage = (): string | null => localStorage.getItem(CONTACTCENTER_STEP);
export const resetStepToLocalStorage = (): void => localStorage.setItem(CONTACTCENTER_STEP, "");
